import { Spell, FightPlayer } from 'web/data/models'
import { MODIFIER_ID } from '../ids/modifier-id'

/**
 * Checks if the given spell/player combo has VOP and applies the VOP CD
 * reduction. Returns a new Spell object with the VOP reduced cooldown.
 */
export function vopRank3Resolver(spell: Spell, fightPlayer: FightPlayer, cooldown: number): number {
    const modPresent = spell.affectedByModifierIds.includes(MODIFIER_ID.ESSENCE_VOP)
        && fightPlayer.modifierIds.includes(MODIFIER_ID.ESSENCE_VOP)

    if (modPresent === false) {
        return cooldown
    }

    // VOP R3 takes off roughly 77% (23% reduction)
    return Math.ceil(cooldown * 0.77)
}
